import "./NlpSidebarHeader.css";
import React, {useEffect, useState} from "react";
import logo from "../../../../assets/nlp-logo.png";

const NlpSidebarHeader: React.FC = () => {

    return (
        <div className="NlpSidebarHeader">
            <div className="NlpSidebarHeader__add-button-container">
                <button className="NlpSidebarHeader__add-button">
                    <span className="text">אני מאמין שלי</span>
                    <span className="icon">＋</span>
                </button>
            </div>
            <img src={logo} alt="NLP Logo" className="NlpSidebarHeader__logo-image" />
        </div>
    );
};

export default NlpSidebarHeader;
